import React, { useState } from 'react';
import ValuationLists from './ValuationLists';
import AddValuation from './AddValuation';

const Valuation = () => {
  const [step, setStep] = useState('viewValuation');
  const [currentValuation, setCurrValuation] = useState(1);
  const [responseContainer, setResponseContainer] = useState([]);

  const parentController = {
    step: step,
    setStep: setStep,
    setCurrValuation: setCurrValuation,
    currentValuation: currentValuation,
    setResponseContainer: setResponseContainer,
    responseContainer: responseContainer
  };
  return (
    <div className="w-12/12 mr-auto xl:px-2 px-2 my-1 ">
      {step == 'viewValuation' ? (
        <ValuationLists parentController={parentController} />
      ) : null}
      {step == 'addValuation' ? (
        <AddValuation parentController={parentController} />
      ) : null}
    </div>
  );
};
export default Valuation;
